@if (formattedValue) {
<span class="value">{{ formattedValue }} </span>
} @if (!formattedValue) {
<empty>{{ emptyMessage }}</empty>
}
